var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRaedSchool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40035 12.7983V8.47024C9.40035 8.19768 9.19356 7.97716 8.9372 7.97716H7.10157C6.8452 7.97716 6.637 8.19768 6.637 8.47161V12.9339C6.637 13.1914 6.83387 13.401 7.07607 13.401H12.175C12.4611 13.401 12.6934 13.1544 12.6934 12.8504L12.6934 9.40234M5.72626 13.4023H3.78441C3.56203 13.4023 3.38074 13.2092 3.38074 12.9723V8.33327C3.38074 8.13741 3.23202 7.97853 3.04789 7.97853H2.33403C1.99977 7.97853 1.87371 7.51422 2.15557 7.32521L7.86925 3.47924C8.02505 3.37514 8.22334 3.37651 8.37773 3.48471L9.40035 4.20367",
    stroke: "#026094",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.40234H15",
    stroke: "#3AC47D",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.40234H14",
    stroke: "#3AC47D",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.40234H14",
    stroke: "#3AC47D",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaedSchool);
export default __webpack_public_path__ + "static/media/RaedSchool.32f8bc584cbfe0d592b0296093c9cbd4.svg";
export { ForwardRef as ReactComponent };